export default {
    desk: {
        settings: 'Настройки',
        logout: 'Выйти',
        history: 'История',
    },
};
